function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import BaseStorage from './base-storage';

function validateNamespace(options) {
  if (!options.namespace) {
    throw new Error('namespace is required');
  } else if (typeof options.namespace !== 'string') {
    throw new Error('namespace should be a string');
  }
}

var DataCapsule = /*#__PURE__*/function (_BaseStorage) {
  _inheritsLoose(DataCapsule, _BaseStorage);

  var _super = _createSuper(DataCapsule);

  function DataCapsule(_ref) {
    var _this;

    var strategy = _ref.strategy,
        namespace = _ref.namespace,
        scope = _ref.scope;
    _this = _BaseStorage.call(this) || this;
    _this.storageStrategy = BaseStorage.verify(strategy);
    _this._options = {
      namespace: namespace,
      scope: scope
    };
    return _this;
  }

  var _proto = DataCapsule.prototype;

  _proto._buildValidateOptions = function _buildValidateOptions(capsuleOptions, options) {
    options = Object.assign({}, capsuleOptions, options);
    options.scope = this.storageStrategy.extendScope(options.scope);
    validateNamespace(options);
    return options;
  };

  _proto.setItem = function setItem(key, value, options) {
    options = this._buildValidateOptions(this._options, options);
    return this.storageStrategy.setItem(key, value, options);
  };

  _proto.getItem = function getItem(key, options) {
    options = this._buildValidateOptions(this._options, options);
    return this.storageStrategy.getItem(key, options);
  };

  _proto.removeItem = function removeItem(key, options) {
    options = this._buildValidateOptions(this._options, options);
    return this.storageStrategy.removeItem(key, options);
  };

  _proto.getAllItems = function getAllItems(options) {
    options = this._buildValidateOptions(this._options, options);
    return this.storageStrategy.getAllItems(options);
  };

  return DataCapsule;
}(BaseStorage);

export { DataCapsule as default };